import industryPartners from '../../components/industryPartners/industryPartners'
import supplierPartners from '../../components/supplierPartners/supplierPartners'
export default ({
    data() {
        return {
            currentMenu: '/security/integrated',
        }
    },
    components: { industryPartners, supplierPartners},
    created() {
        var route = this.$route.path
        this.currentMenu = '1-1'
    },
    watch:{
        //监听路由变化
        $route(to,from){
            var route = to.path
            this.currentMenu = '1-1'
        }
    },
    methods: {
        selectMenu(page){
            var route = this.$route.path
            this.currentMenu = page
        }
    }
})


// WEBPACK FOOTER //
// ./src/pages/partners/partners.vue.js